import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get } from "api/utils"
import { CursorType } from "utils/types"
export type ShiftHistoryType = {
    key: string;
    uuid: string;
    identity: string;
    associated_type: string;
    associated_uuid: string;
    shift: string;
    collab: string;
    request: string;

    display_name?: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: ShiftHistoryType) => void;
};

// Domain object ShiftHistory
export class ShiftHistory implements ShiftHistoryType {
    key = "";
    uuid = "";
    identity = "";

    associated_type = "";
    associated_uuid = "";
    shift = "";
    collab = "";
    request = "";

    display_name = "";
    date_created = "";
    date_updated = "";

    constructor(attributes: ShiftHistoryType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: ShiftHistoryType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class ShiftHistoryStore extends BaseStore<ShiftHistoryType, ShiftHistory> {


    async fetchShiftHistory(uuid: string) {
        // Autogenerated
        const response = await api_get(`/shift-history?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }


    async fetchListByIdentityShiftHistory(identity_uuid: string, cursor?: CursorType): Promise<ShiftHistoryType[]>  {
        // Autogenerated
        var url = `/shift-history/by-identity?identity=${identity_uuid}` +
            (cursor ? `&cursor=${cursor}` : '');
        const response = await api_get(url);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByIdentityShiftHistory(identity_uuid, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but ShiftHistoryStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };


    async fetchListByAssociationShiftHistory(identity: string, associated_type: string, associated_uuid: string, cursor?: CursorType): Promise<ShiftHistoryType[]>  {
        // Autogenerated
        const url = "/shift-history/list-by-association";
        const params = {
            identity,
            associated_type,
            associated_uuid,
            cursor: cursor || ''
        };
        const response = await api_get(url, params);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByAssociationShiftHistory(identity, associated_type, associated_type, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but ShiftHistoryStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };

    async fetchListBySupport(identity: string, cursor?: CursorType): Promise<ShiftHistoryType[]>  {
        const url = "/shift-history/list/by-support";
        const response = await api_get(url, { identity, cursor: cursor || "" } );
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            // if(data?.cursor) {
            //     this.fetchListByIdentityShiftHistory(identity, data.cursor);
            // }
            // This returns as possibly incomplete list due to the cursor,
            // but ShiftHistoryStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [] as ShiftHistoryType[];
    };


    modelConstructor() {
        return ShiftHistory;
    }

}
